// extracted by mini-css-extract-plugin
module.exports =  {"faq":"FAQ-pSHB__faq","faq--inline":"FAQ-EuRH__faq--inline"};